import type { PieValueType } from '@mui/x-charts/models';
import { theme } from '@side/pantry';
import type { ReportingSummaryResult } from '../types';

export type TransactionTypeId = NonNullable<
  ReportingSummaryResult['transactionType']
>;

export const TRANSACTION_TYPE_CHART_COLORS: Record<
  TransactionTypeId,
  string | undefined
> = {
  LISTING: theme.palette.warning[600],
  OFFER: theme.palette.periwinkle.main,
  LEASE_LANDLORD: theme.palette.violet[600],
  LEASE_TENANT: theme.palette.secondary.dark,
  REFERRAL: '#D45087', // Chart/Cranberry
} as const;

export const TRANSACTION_TYPE_LABELS: Record<TransactionTypeId, string> = {
  LISTING: 'Listings',
  OFFER: 'Offers',
  LEASE_LANDLORD: 'Lease (Landlord)',
  LEASE_TENANT: 'Lease (Tenant)',
  REFERRAL: 'Referrals',
} as const;

export type SummaryResult = Pick<
  ReportingSummaryResult,
  'agentNetShare' | 'teamNetShare' | 'brandNetShare' | 'transactionType'
>;

export function mapTransactionTypeBreakdownData(
  data: SummaryResult[],
  showNet: 'agent_net' | 'team_net' | 'brand_net',
): PieValueType[] {
  return data.flatMap((item) =>
    item.transactionType
      ? {
          id: item.transactionType,
          label: TRANSACTION_TYPE_LABELS[item.transactionType],
          value: (() => {
            switch (showNet) {
              case 'agent_net':
                return item.agentNetShare ?? 0;
              case 'team_net':
                return item.teamNetShare ?? 0;
              case 'brand_net':
                return item.brandNetShare ?? 0;
              default:
                return 0;
            }
          })(),
          color: TRANSACTION_TYPE_CHART_COLORS[item.transactionType],
        }
      : [],
  );
}
